// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"123":"56105995","489":"5a18a99f","999":"cf2f2446"}[chunkId] + ".js";
};